export const ACTIVATE_ACCOUNT_RESET = 'ACTIVATE_ACCOUNT_RESET'
export const ACTIVATE_ACCOUNT_SET_ERROR = 'ACTIVATE_ACCOUNT_SET_ERROR'
export const ACTIVATE_ACCOUNT_TOGGLE_LOADING = 'ACTIVATE_ACCOUNT_TOGGLE_LOADING'
export const ACTIVATE_ACCOUNT_SET_ACTIVATED = 'ACTIVATE_ACCOUNT_SET_ACTIVATED'
export const ACTIVATE_ACCOUNT_SET_EXPIRED_TOKEN = 'ACTIVATE_ACCOUNT_SET_EXPIRED_TOKEN'
export const ACTIVATE_ACCOUNT_SET_INVALID_TOKEN = 'ACTIVATE_ACCOUNT_SET_INVALID_TOKEN'
export const ACTIVATE_ACCOUNT_SET_EMAIL = 'ACTIVATE_ACCOUNT_SET_EMAIL'
